/// <reference path="FocusFirstInput.js" />

class MessageSend extends FocusFirstInput {
	constructor(el, options) {
		super(el, options);
		var submit = this.el.querySelector('input[type=submit]');
		this.safeObserve(submit, 'click', this.onSubmit.bind(this));

		// assume that we are online
		this.online = true;
	}

	onSubmit(ev) {
		axios(this.options.loginStatusUrl, {
			method: 'get',
			params: {
				nocache: Math.random()
			}
		}).then(this.onLoginCheck.bind(this));

		if (!this.online) {
			ev.preventDefault();
			ev.stopPropagation();
			throw new Error(this.options.loginStatusWarning);
		}
	}

	onLoginCheck(req) {
		var json = req.data;
		this.online = json.online;
	}
}
